import { render, staticRenderFns } from "./FournisseurTable.vue?vue&type=template&id=5dd72850&"
import script from "./FournisseurTable.vue?vue&type=script&lang=js&"
export * from "./FournisseurTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports